import { Box } from "@mui/material";

import Header from "../../components/Header";
//import DataGrid from "devextreme-react/data-grid";

import React, { useEffect, useState } from "react";

import { Stack } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";
import themes from "devextreme/ui/themes";

import FilterBox from "../../components/vehicle/filter";
import { useDispatch, useSelector } from "react-redux";
import VehicleList from "../../components/vehicle/vehicleList";
import { getVehicle, setFilter } from "../../store/reducers/vehicle";

const Vehicle = () => {
  const vehicleDataList = useSelector((state) => state.vehicle.vehicleData);
  const filter = useSelector((state) => state.vehicle.filter);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isCompanyFilter, setIsCompanyFilter] = useState(false);
  const [compName, setCompanyName] = useState("");
  const [compId, setCompId] = useState("");
  const logedUser = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const setFilters = (field, value) => {
    // console.log(field, value);
    dispatch(setFilter({ ...filter, [field]: value }));
    setCompId(value);
  };

  useEffect(() => {
    if (vehicleDataList == null) {
      dispatch(getVehicle(filter));
    }
  }, [vehicleDataList, filter, dispatch]);
  useEffect(() => {
    //console.log(Object.keys(filter).length);
    if (Object.keys(filter).length > 0) {
      dispatch(getVehicle(filter));
    }
  }, [filter, dispatch]);
  const filterIsCompany = (filterData) => {
    // console.log("-----------");
    // console.log(filterData);
    // console.log("----------");
    if (filterData !== null) {
      setCompanyName(filterData[0]);
      setIsCompanyFilter(true);
    } else {
      setCompanyName(null);
      setIsCompanyFilter(false);
    }

    //const data = selectedRowsData[0];

    // setFilters(filterData);
  };

  return (
    <Box m="20px">
      <Header
        title="Тээврийн хэрэгсэл"
        subtitle="Тээврийн хэрэгслийн жагсаалт"
      />
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 12" },
        }}
      >
        {/* <Box sx={{ gridColumn: "span 12" }}>
          <FilterBox getFilters={setFilters} filterCompany={filterIsCompany} />
        </Box> */}
        <Box sx={{ gridColumn: "span 12" }}>
          <FilterBox getFilters={setFilters} filterCompany={filterIsCompany} />
          <VehicleList
            vehicleListData={vehicleDataList}
            comptData={compName}
            compId={compId}
            isCompanyFilter={isCompanyFilter}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Vehicle;
